import { render } from "./eventRegistration.vue?vue&type=template&id=dabc889a&scoped=true"
import script from "./eventRegistration.vue?vue&type=script&lang=js"
export * from "./eventRegistration.vue?vue&type=script&lang=js"

import "./eventRegistration.vue?vue&type=style&index=0&id=dabc889a&lang=scss&scoped=true"
import "./eventRegistration.vue?vue&type=style&index=1&id=dabc889a&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dabc889a"]])

export default __exports__